export const QUIZ_EXAMPLE_BANK = {
  "short-answer": [
    {
      prompt: "In your own words, summarise the central argument presented in the passage.",
      expectedResponse: "Learner-written summary focusing on the author’s claim and supporting evidence.",
      feedback: {
        correct: "Great job highlighting the author’s main claim and supporting evidence.",
        incorrect: "Revisit the passage and identify the author’s central claim along with at least two pieces of evidence.",
      },
      score: 5,
    },
    {
      prompt: "Explain why the Nile river was essential to Ancient Egyptian civilisation.",
      expectedResponse: "Learners should reference agriculture, trade, or transportation supported by the river.",
      feedback: {
        correct: "Your explanation captures the role the Nile played in supporting communities.",
        incorrect: "Consider how the Nile impacted food production, travel, and trade networks.",
      },
      score: 4,
    },
  ],
  picklist: [
    {
      prompt: "Which renewable energy source converts sunlight directly into electricity?",
      options: [
        { label: "Wind Turbines", value: "wind" },
        { label: "Hydroelectric Dams", value: "hydro" },
        { label: "Photovoltaic Solar Panels", value: "solar" },
        { label: "Geothermal Heat Pumps", value: "geothermal" },
      ],
      correctValue: "solar",
      feedback: {
        correct: "Correct — solar panels transform sunlight into electricity.",
        incorrect: "Look for the option that describes converting sunlight directly into electricity.",
      },
      score: 3,
    },
    {
      prompt: "Select the literary device that involves giving human characteristics to non-human things.",
      options: [
        { label: "Metaphor", value: "metaphor" },
        { label: "Alliteration", value: "alliteration" },
        { label: "Personification", value: "personification" },
        { label: "Hyperbole", value: "hyperbole" },
      ],
      correctValue: "personification",
      feedback: {
        correct: "Personification is the technique of attributing human traits to non-human subjects.",
        incorrect: "Revisit the definitions of each literary device and try again.",
      },
      score: 2,
    },
  ],
  "true-false": [
    {
      prompt: "True or False: Sound travels faster through air than through water.",
      correctValue: false,
      feedback: {
        correct: "Correct — sound waves travel faster through water than through air.",
        incorrect: "Remember that the density of a medium affects how quickly sound travels.",
      },
      score: 1,
    },
    {
      prompt: "True or False: The Earth completes one rotation on its axis approximately every 24 hours.",
      correctValue: true,
      feedback: {
        correct: "Correct — a full rotation takes roughly 24 hours, creating our day/night cycle.",
        incorrect: "Consider how Earth’s rotation relates to the passage of time across a day.",
      },
      score: 1,
    },
  ],
};

export const QUIZ_QUESTION_TYPES = [
  { value: "short-answer", label: "Short answer" },
  { value: "picklist", label: "Picklist" },
  { value: "true-false", label: "True / False" },
];

export default QUIZ_EXAMPLE_BANK;
